import React from 'react';
import { Switch, Route, Redirect } from "react-router-dom";

import Error from "./pages/Error";
import Index from "./pages/Index";
import Winners from "./pages/Winners";

export default class Root extends React.Component {
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location !== this.props.location) {
      AnalyticsSDK.trackPageView();
    }
  }

  render() {
    return (
      <Switch>
        <Route path="/" render={props => <Index {...props} isWelcome={true} />} exact />
        <Route path="/404" component={Error} exact />
        <Route path="/:id/winners" component={Winners} exact />
        <Route path="/new" render={props => <Index {...props} isNewProject={true} />} exact />
        <Route path="/:id" render={props => <Index {...props} />} exact />
        <Redirect from="*" to="/404" />
      </Switch>
    );
  }
}
